module.exports = __webpack_public_path__ + "0fe777dd73bd8449498b8c47c8fff672.svg";